<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M11.0161 7.62177L17.4378 0H15.9161L10.3401 6.61788L5.88659 0H0.75L7.48457 10.0074L0.75 18H2.27182L8.16018 11.0113L12.8634 18H18L11.0157 7.62177H11.0161ZM8.93175 10.0956L8.24939 9.09906L2.82016 1.16971H5.15759L9.53905 7.56895L10.2214 8.56546L15.9168 16.8835H13.5793L8.93175 10.096V10.0956Z" fill="#193742"/>
    </svg>
</template>

<script lang="ts" setup></script>